import axios from 'axios'
import { ref } from 'vue'
import { useToast } from 'vue-toast-notification'

export function useHubSpotSyncIssues({
    onResolved = () => {},
    onRetried = () => {},
    onError = () => {},
}) {
    const $toast = useToast()
    const toastOptions = {
        position: 'top',
        duration: 5000,
        dismissible: true,
        pauseOnHover: true,
    }

    const resolving = ref(false)
    const retrying = ref(false)

    const resolve = async (id) => {
        try {
            resolving.value = true
            await axios.post(`/api/hubspot-sync-issues/${id}/resolve`)
            $toast.success('Cas marqué comme traité', toastOptions)
            onResolved()
        } catch (error) {
            onError(error)
        } finally {
            resolving.value = false
        }
    }

    const retry = async (id) => {
        try {
            retrying.value = true
            const response = await axios.post(`/api/hubspot-sync-issues/${id}/retry`)
            $toast.success(response.data?.message ?? 'Synchro relancée', toastOptions)
            onRetried()
        } catch (error) {
            // Refus expliqué par l'API (fiche supprimée) : on affiche son message
            if (error.response?.status === 422 && error.response.data?.message) {
                $toast.error(error.response.data.message, toastOptions)
            } else {
                onError(error)
            }
        } finally {
            retrying.value = false
        }
    }

    return { resolving, retrying, resolve, retry }
}
